/** Hard-coded server. Operators never see or change this. */
export const SERVER_ADDRESS = "ptt.echo911.com:9998";

/** App identity reported in DEVICE_CONFIG.AppName.
 *
 *  DO NOT change this without server-side coordination. The manager
 *  appears to maintain an allowlist of accepted client app names (the
 *  WalkieFleet stack ships "FleetConsole" / "FleetManager" /
 *  "FleetStatistics"). Anything else is silently dropped (no NACK,
 *  no ACK — connection just hangs after DEVICE_CONFIG, only PING/PONG
 *  continues). This is different from the version gate (which DOES
 *  return a NACK with ResponseCode:1).
 *
 *  We pose as "FleetConsole" so the manager treats us as the standard
 *  dispatcher web client. Our actual app identity surfaces through the
 *  custom DeviceDescription string sent in DEVICE_CONFIG.DeviceData
 *  (see lib/MCPTTClient.ts: `MANUFACTURER=WLLC;MODEL=APIClientWEB;...`)
 *  — that field is logged by the manager but not allowlisted. */
export const APP_NAME = "FleetConsole";

/** Wire-protocol version reported in DEVICE_CONFIG.VersionName.
 *
 *  DO NOT change this without first confirming the manager will still
 *  accept the new value. The server enforces a minimum (the
 *  CONFIG_SERVER_RESPONSE_NACK frame includes a `MinVersionName`
 *  field — currently "5.0") and rejects any client whose VersionName
 *  is below it with `ResponseCode: 1` ("Invalid client version").
 *
 *  5.7.7 is the version the legacy WalkieFleet bundle reports and is
 *  known to be accepted by the live ptt.echo911.com:9998 manager.
 *  Bumping it requires server-side coordination. The actual app
 *  release version is tracked in app/package.json. */
export const APP_VERSION = "5.7.7";

/** Fixed brand strings. */
export const BRAND_TITLE   = "MCPTT";
export const BRAND_TAGLINE = "Mission Critical Push-To-Talk";

/**
 * Google Maps JavaScript API key.
 *
 * NOTE on security: Google Maps JS API keys are inherently public — they
 * ship in the JS bundle and are visible to anyone who views the page
 * source. The security model is HTTP-referrer + API-restriction in the
 * Google Cloud Console, NOT key secrecy.
 *
 * REQUIRED hardening before this goes truly public:
 *   1. Go to Google Cloud Console → APIs & Services → Credentials → this key.
 *   2. Application restrictions → "Websites" → add:
 *        https://dispatch.mcptt.com/*
 *      (and any staging hosts).
 *   3. API restrictions → "Restrict key" → enable ONLY:
 *        - Maps JavaScript API
 *        - (optional) Places API, Geocoding API if we use them later.
 *
 * Until #2 is done, this key can be lifted by anyone and used on their
 * own domain — Google will bill the key's project for that traffic.
 */
export const GOOGLE_MAPS_API_KEY = "AIzaSyABbrk5tE0cfkihVDscopBUdbTZT11n47o";
